import { translate } from '../../base/i18n/functions';
import { IconFaceMaskOn, IconFaceMaskOff } from '../../base/icons/svg/index';
import { connect } from '../../base/redux/functions';
import { AbstractButton } from '../../base/toolbox/components';
// @ts-ignore
import { setOverflowMenuVisible } from '../../toolbox/actions';
import { toggleFaceMesh } from '../actions';
import { isFaceMeshEnabled, checkFilterSupport } from '../functions';
/**
 * Component that renders a toolbar button for toggling noise suppression.
 */
class FaceMeshButton extends AbstractButton {
    constructor() {
        super(...arguments);
        this.accessibilityLabel = 'toolbar.accessibilityLabel.faceMask';
        this.icon = IconFaceMaskOn;
        this.label = 'toolbar.faceMask';
        this.tooltip = 'toolbar.faceMask';
        this.toggledIcon = IconFaceMaskOff;
        this.toggledLabel = 'toolbar.disableFaceMask';
    }
    /**
     * Handles clicking / pressing the button.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        const { dispatch } = this.props;
        dispatch(toggleFaceMesh());
        dispatch(setOverflowMenuVisible(false));
    }
    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._isFaceMeshEnabled;
    }
}
/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {Props}
 */
function _mapStateToProps(state) {
    return {
        _isFaceMeshEnabled: isFaceMeshEnabled(state),
        visible: checkFilterSupport()
    };
}
// @ts-ignore
export default translate(connect(_mapStateToProps)(FaceMeshButton));
